export default "__VITE_ASSET__38595d72__"